import { defineStyleConfig } from "@chakra-ui/react";

const TextStyle = defineStyleConfig({
    variants:{
        body:{
            fontFamily:"poppins"
        },
        InputHeader:{
            fontFamily:"poppins",
            fontSize:"14px"
        }
    }
})

export {TextStyle}